export default __webpack_public_path__ + "static/media/nexus_logo_ddd.f57ad517.png";